import useMultiEquipmentTrackingEnabled from 'hooks/settings/useMultiEquipmentTrackingEnabled/useMultiEquipmentTrackingEnabled';
import { t } from 'utils/localize';
import { getEquipmentDisplay } from 'utils/stringUtils';
import useActivityReportExportColumns, {
  buildActivityReportExportColumnsData,
} from 'containers/activity-reports/hooks/useActivityReportExportColumns';
import { IEquipmentActivityTableRowInfo } from './useEquipmentActivity';
import useNoEquipmentName from './useNoEquipmentName';

export default function useEquipmentActivityReportExport() {
  const noEquipmentName = useNoEquipmentName();
  const { orderedColumns, exportColumnsByKey } = useActivityReportExportColumns(true);
  const hasMultiEquipmentTracking = useMultiEquipmentTrackingEnabled();

  function getExportData<DataType extends IEquipmentActivityTableRowInfo>(
    data: DataType[],
    detailColumns?: (row: DataType) => object
  ) {
    return data.map((row) => {
      const total = hasMultiEquipmentTracking ? row.totalHours + row.addOnTime : row.totalHours;

      return {
        [t('Equipment')]: row.equipment ? getEquipmentDisplay(row.equipment) : noEquipmentName,
        ...(detailColumns ? detailColumns(row) : {}),
        ...buildActivityReportExportColumnsData(orderedColumns, exportColumnsByKey, row, total),
      };
    });
  }

  return getExportData;
}
